export default {
      id: "oc-pdf-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-pdf",
      toString: function () {
        return this.url;
      }
    }